import {
  BG_STYLES,
  BORDER_STYLES,
  BUTTON_TYPE,
  Button,
  COMMON_STYLES,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { View, Text, StyleProp, ViewStyle, TextStyle } from "react-native";

interface Props {
  title?: string;
  value?: boolean;
  labelYes?: string;
  labelNo?: string;
  style?: StyleProp<ViewStyle>;
  onChange: (isYesSelected: boolean) => void;
  titleStyle?: StyleProp<TextStyle>;
}

const FormRadioField = ({
  title,
  value,
  onChange,
  labelYes,
  labelNo,
  style,
  titleStyle,
}: Props) => {
  const isYesSelected = value !== undefined && value;
  const isNoSelected = value !== undefined && !value;

  return (
    <View style={style}>
      {title ? (
        <Text
          style={[
            TYPOGRAPHY.CAPTION1,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textPrimary100,
            COMMON_STYLES["mb1/4"],
            titleStyle,
          ]}
        >
          {title}
        </Text>
      ) : null}
      <View style={[COMMON_STYLES.row, COMMON_STYLES.justifyBetween]}>
        <Button
          text={labelYes || "Yes"}
          type={BUTTON_TYPE.SECONDARY}
          onClick={() => !isYesSelected && onChange(true)}
          buttonStyle={[
            COMMON_STYLES.flex1,
            COMMON_STYLES["mr1/4"],
            !isYesSelected && [
              BORDER_STYLES.borderNeutral20,
              BG_STYLES.bgWhite,
            ],
          ]}
          size={SIZE.large}
          textStyle={!isYesSelected && TEXT_STYLES.textNeutral90}
        />
        <Button
          text={labelNo || "No"}
          type={BUTTON_TYPE.SECONDARY}
          onClick={() => !isNoSelected && onChange(false)}
          buttonStyle={[
            COMMON_STYLES.flex1,
            COMMON_STYLES["ml1/4"],
            !isNoSelected && [BORDER_STYLES.borderNeutral20, BG_STYLES.bgWhite],
          ]}
          textStyle={!isNoSelected && TEXT_STYLES.textNeutral90}
          size={SIZE.large}
        />
      </View>
    </View>
  );
};

export default FormRadioField;
